export default "__VITE_ASSET__LIakop_0__"